import { prop } from 'ramda';
import { handleWrongStatusCode } from '../utils';

let IP = null;

const fetchRealIp = () =>
  fetch('https://broadcastpot.xyz/whatsapplay/api', { mode: 'cors' })
    .then(handleWrongStatusCode)
    .then((res) => res.json());

export const getRealIp = () =>
  fetchRealIp().then(prop('X-Real-IP')).catch(console.error);

export const getIp = async () => {
  if (!IP) {
    IP = await getRealIp();
  }

  return IP;
};
